import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { FsMessage } from '@firestitch/message';

import { Subject, of, zip } from 'rxjs';
import { switchMap, tap, map, takeUntil } from 'rxjs/operators';

import { EnvironmentData, DiseaseData } from '@app/core/data';
import { SessionService, AuthService } from '@app/core/services';
import { Environment } from '@app/common/interfaces';

import { EnvironmentCreate } from '../../interfaces';


@Component({
  selector: 'app-diseases',
  templateUrl: './diseases.component.html',
  styleUrls: ['./diseases.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiseasesComponent implements OnInit, OnDestroy {

  @Input() public environmentCreate: EnvironmentCreate = null;

  // @Output() public environmentCreateChange = new EventEmitter<EnvironmentCreate>();
  @Output() public completed = new EventEmitter();

  public diseases = [];

  private _destroy$ = new Subject();

  constructor(
    private _diseaseData: DiseaseData,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private _fsMessage: FsMessage,
    private _environmentData: EnvironmentData,
    private _sessionService: SessionService,
    private _authService: AuthService,
  ) { }

  public ngOnInit(): void {
    this._diseaseData.gets()
      .pipe(
        takeUntil(this._destroy$)
      )
      .subscribe((response) => {
        this.diseases = response;
        this._cd.markForCheck();
      });
  }

  public save = () => {
    const account = this._sessionService.account();

    return this._environmentData.post(this.environmentCreate)
      .pipe(
        switchMap((environment: Environment) => {
          return zip(
            this._authService.reloadPermissions(),
            this._environmentData.switch(account.id, environment.id),
          )
            .pipe(
              map(() => {
                this._sessionService.environment(environment);

                return environment;
              }),
              takeUntil(this._destroy$),
            );
        }),
        tap((environment: Environment) => {
          this._fsMessage.success('Saved Changes');
          this.completed.emit();
          this._router.navigate(['/dashboard']);
        }),
      );
  };

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
